interface ProgressLineProps {
    stepNumber: number;
    buttonNumber: number;
}

const ProgressLine = ({stepNumber, buttonNumber}: ProgressLineProps): JSX.Element => {
    const isStepPassed = stepNumber > buttonNumber;
    const isCurrentStep = stepNumber === buttonNumber;

    const lineBackgroundColor = isStepPassed ? 'bg-celeste-primary' : 'bg-secondary';

    const desktopClasses =
        stepNumber !== buttonNumber
            ? `h-1px w-100 ${lineBackgroundColor}`
            : `${isCurrentStep ? 'lineh bg-celeste-primary' : ''}`;

    const mobileClasses =
        stepNumber !== buttonNumber
            ? `w-1px h-100 ${lineBackgroundColor}`
            : `${isCurrentStep ? 'linev bg-celeste-primary' : ''}`;

    return (
        <>
            <div className="d-none d-lg-block position-relative w-75px mb-3 border-left-1">
                <div className={desktopClasses}></div>
            </div>
            <div className="d-flex d-lg-none position-relative justify-content-center h-25px border-top-1">
                <div className={mobileClasses}></div>
            </div>
        </>
    );
};

export default ProgressLine;
